import * as yup from 'yup';
import { yupRequiredNonEmptyString } from '../utils/yupRequiredNonEmptyString';

export const SCAN_PIPELINE_STATUS_VALUES = [
  'Pending',
  'In Progress',
  'Completed',
  'Completed With Errors',
  'Error',
  'Uploading',
] as const;

// Derive the type from the array using TypeScript
export type ScanPipelineStatuses = (typeof SCAN_PIPELINE_STATUS_VALUES)[number];

// Create comma-separated string from the same source, used to show available scan search values in the search bar popup
export const SCAN_PIPELINE_STATUSES_STRING =
  SCAN_PIPELINE_STATUS_VALUES.join(', ');

export const ScanSchema = yup.object().shape({
  // Required fields
  id: yupRequiredNonEmptyString('ID'),
  scanDate: yupRequiredNonEmptyString('Scan date'),
  name: yupRequiredNonEmptyString('Name'),
  blockID: yupRequiredNonEmptyString('Block ID'),
  blockName: yupRequiredNonEmptyString('Block name'),
  ranchID: yupRequiredNonEmptyString('Ranch ID'),
  ranchName: yupRequiredNonEmptyString('Ranch name'),
  customerID: yupRequiredNonEmptyString('Customer ID'),
  customerName: yupRequiredNonEmptyString('Customer name'),
  customerShortCode: yupRequiredNonEmptyString('Customer short code'),
  pipelineStatus: yup
    .string()
    .oneOf([...SCAN_PIPELINE_STATUS_VALUES], 'Invalid pipeline status')
    .required('Pipeline status is required'),
  fromDate: yup.string().nullable().required('From date is required'),

  // Optional fields
  thruDate: yup.string().nullable(),
  junk: yup.boolean().nullable(),
  qaNotes: yup.string().nullable(),
  qaDate: yup.string().nullable(),
  scanQuality: yup.string().nullable(),
  uploadStart: yup.string().nullable(),
  uploadEnd: yup.string().nullable(),
  pipelineStart: yup.string().nullable(),
  pipelineEnd: yup.string().nullable(),
  pipelineNotes: yup.string().nullable(),
  cameraID: yup.string().nullable(),
  userEmail: yup.string().nullable(),
  flashVersion: yup.string().nullable(),
  appVersion: yup.string().nullable(),
  cameraIDs: yup.array().of(yup.string()).nullable(),
  collectionIDs: yup.array().of(yup.string()).nullable(),
  flashVersions: yup.array().of(yup.string().nullable()).nullable(),
  appVersions: yup.array().of(yup.string().nullable()).nullable(),
});

export type Scan = yup.InferType<typeof ScanSchema>;
